// @ts-nocheck
import * as Types from '../../@types/apiql.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TProfilesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type TProfilesQuery = { __typename?: 'Query', viewer: { __typename?: 'Viewer', id: string, profiles: Array<{ __typename?: 'ProfileType', createdAt: any, current: boolean, id: string, imageUrl?: string | null, lastUpdatedAt: any, name?: string | null }> } };


export const ProfilesDocument = gql`
    query Profiles {
  viewer {
    id: magineId
    profiles {
      createdAt
      current
      id
      imageUrl
      lastUpdatedAt
      name
    }
  }
}
    `;

/**
 * __useProfilesQuery__
 *
 * To run a query within a React component, call `useProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfilesQuery(baseOptions?: Apollo.QueryHookOptions<TProfilesQuery, TProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TProfilesQuery, TProfilesQueryVariables>(ProfilesDocument, options);
      }
export function useProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TProfilesQuery, TProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TProfilesQuery, TProfilesQueryVariables>(ProfilesDocument, options);
        }
export type ProfilesQueryHookResult = ReturnType<typeof useProfilesQuery>;
export type ProfilesLazyQueryHookResult = ReturnType<typeof useProfilesLazyQuery>;
export type ProfilesQueryResult = Apollo.QueryResult<TProfilesQuery, TProfilesQueryVariables>;